import { Pipe, PipeTransform } from '@angular/core';

import { replaceMsgFormat, type ReplaceParams } from '../../core/utils/replaceMsgFormat';

@Pipe({
  name: 'finMsgFormat',
  pure: true,
  standalone: false,
})
export class MsgFormatPipe implements PipeTransform {
  transform(input: string, args: ReplaceParams = []): string {
    return replaceMsgFormat(input, args);
  }
}
